import { Fragment, PropsWithChildren } from 'react';
import Nav from './nav';

type DashboardLayoutProps = PropsWithChildren<{}>;

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <>
      <Nav />
      {children}
    </>
  );
}
